export default __webpack_public_path__ + "static/media/Goru-logo.4bb39c4f.svg";